module.exports = __webpack_public_path__ + "static/media/vf-status-inactive.7bb90af4.svg";